import React, { ChangeEvent, useEffect, useState } from "react";
import Breadcrumb from "../../components/BreadCrumb";
import Button from "../../components/Buttons";
import ModifyProfileMenu from "../../components/ModifyProfileMenu";
import BasicInformation from "../../components/BasicInformation";
import MediaComponent from "../../components/MediaComponent";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api/api";
import { CONSTANTS } from "../../constants/Constants";
import LoadSpinner from "../../components/LoadingSpinner";
import QuestionAndAnswers from "../../components/QAComponent";
import Experience from "../../components/ExperienceComponent";
import Education from "../../components/EducationComponent";
import { convertToFormData, copyToClipboard } from "../../utils/helpers";
import clipBoardIcon from "../../assets/icons/clipboard_icon.svg";
import { useToastContext } from "../../context/ToastContext";
import ProfilePreview from "../../components/ProfilePreview";
import Swal from "sweetalert2";
import {getCityList, updateResourceStatus, verifyDisplayName, updateResource} from "../../services/api/profile"
import { useGlobalContext } from "../../context/GlobalContext";

const ModifyProfile: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToastContext();
  const {isLoading, setIsLoading} = useGlobalContext()
  const [currentProfile, setCurrentProfile] = useState<Record<string, any>>({});
  const [isFormUpdated, setIsFormUpdated] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("");
  const [payload, setPayload] = useState<Record<string, any>>({});
  const [countryOptions, setCountryOptions] = useState<{}[]>([]);
  const [cityOptions, setCityOptions] = useState<{}[]>([]);
  const [displayNameMessage, setDisplayNameMessage] = useState<{
    message: string;
    success: boolean;
  }>({ message: "", success: false });
  const [cityError, setCityError] = useState<string>("");
  const [selectDateError, setSelectDateError] = useState<boolean>(false);
  const [newVideo, setNewVideo] = useState<{
    mediaFile?: File | null;
    mediaUrl?: string;
    name: string;
    status: string;
    type: string;
  }>({
    name: "",
    status: "",
    type: "VIDEO",
  });
  const [newQuestion, setNewQuestion] = useState<{
    answer?: string;
    question?: string;
    status: "ENABLED" | "DISABLED";
  }>({
    answer: "",
    question: "",
    status: "ENABLED",
  });
  const [newExp, setNewExp] = useState<any>(null);
  const [newEdu, setNewEdu] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentItemIndex, setCurrentItemIndex] = useState<number | null>(null);
  const [isDateVisible, setIsDateVisible] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [isLinkDisabled, setIsLinkDisabled] = useState<boolean>(false);
  const [isMediaDisabled, setIsMediaDisabled] = useState<boolean>(false);

  const journeyChangeHandler = (e: ChangeEvent, journey: string) => {
    let target = e.target as HTMLInputElement;
    let name = target.name;
    setIsFormUpdated(true);
    if (target.type === "file" && target.files) {
      if (target.files[0].type.split("/")[0] !== "image") {
        showToast(CONSTANTS.APP_ERRORS.ONLY_IMAGES_ERROR, "error");
      } else {
        let file = target?.files[0];
        let fileURL = URL.createObjectURL(target?.files[0]);

        journey === CONSTANTS.EXPERIENCE_HEADING_TXT
          ? setNewExp({
            ...newExp,
            [name]: file,
            [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL]:
              fileURL,
          })
          : setNewEdu({
            ...newEdu,
            [name]: file,
            [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL]:
              fileURL,
          });
      }
    } else {
      journey === CONSTANTS.EXPERIENCE_HEADING_TXT
        ? setNewExp({ ...newExp, [name]: target.value })
        : setNewEdu({ ...newEdu, [name]: target.value });
    }
  };

  const journeyErrorHandler = (journey: string) => {
    if (
      journey ===
      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EDUCATION
    ) {
      if (!newEdu?.institute) {
        showToast(CONSTANTS.APP_ERRORS.INSTITUTE_ERROR, "error");
        return false;
      } else if (!newEdu?.degree) {
        showToast(CONSTANTS.APP_ERRORS.DEGREE_ERROR, "error");
        return false;
      }
      return true;
    } else if (
      journey ===
      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EXPERIENCE
    ) {
      if (!newExp?.organizationName) {
        showToast(CONSTANTS.APP_ERRORS.ORGANIZATION_ERROR, "error");
        return false;
      } else if (!newExp?.title) {
        showToast(CONSTANTS.APP_ERRORS.TITLE_ERROR, "error");
        return false;
      }
      return true;
    }
    return;
  };

  const saveJourneyHandler = (journey: string) => {
    if (journeyErrorHandler(journey)) {
      let updatedData = [...payload[journey]];
      if (currentItemIndex !== null) {
        updatedData[currentItemIndex] =
          journey ===
            CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EXPERIENCE
            ? { ...newExp }
            : { ...newEdu };
      } else {
        if (
          journey ===
          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EXPERIENCE
        ) {
          updatedData.push({ ...newExp });
          setNewExp({});
        } else {
          updatedData.push({ ...newEdu });
          setNewEdu({});
        }
      }

      setPayload({
        ...payload,
        [journey]: updatedData,
      });
      setIsModalOpen(false);
      setCurrentItemIndex(null);
    }
  };

  const quesChangeHandler = (e: ChangeEvent) => {
    let target = e.target as HTMLInputElement;
    let name = target.name;
    setIsFormUpdated(true);
    if (currentItemIndex !== null) {
      setPayload({
        ...payload,
        [payload[
          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS
        ][currentItemIndex][name]]: target.value,
      });
    }
    setNewQuestion({ ...newQuestion, [name]: target.value });
  };
  const saveQuesHandler = () => {
    if (!newQuestion.answer || !newQuestion.question) {
      showToast(CONSTANTS.APP_ERRORS.EMPTY_FIELDS_ERROR, "error");
    } else {
      let updatedQA = [
        ...payload[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS
        ],
      ];
      if (currentItemIndex !== null) {
        // Update existing item
        updatedQA[currentItemIndex] = { ...newQuestion };
      } else {
        // Add new item
        updatedQA.push({ ...newQuestion });
      }

      setPayload({
        ...payload,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_QUESTIONS]:
          updatedQA,
      });

      setIsModalOpen(false);
      setNewQuestion({
        answer: "",
        question: "",
        status: "ENABLED",
      });
      setCurrentItemIndex(null);
    }
  };

  const mediaChangeHandler = (e: ChangeEvent) => {
    let target = e.target as HTMLInputElement;
    let name = target.name;
  
    setIsFormUpdated(true);
  
    if (target.type === "file" && target.files) {
      let selectedFile = target.files[0];
  
      if (selectedFile.type.split("/")[0] !== "video") {
        showToast(CONSTANTS.APP_ERRORS.ONLY_VIDEOS_ERROR, "error");
        return;
      }
  
      setIsLinkDisabled(true);
      setIsMediaDisabled(false);
  
      if (currentItemIndex !== null) {
        setPayload({
          ...payload,
          [payload[
            CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
          ][currentItemIndex][name]]: selectedFile,
        });
      }
  
      setNewVideo({
        ...newVideo,
        [name]: selectedFile,
        name: selectedFile.name.split(".")[0],
      });
      target.value = "";
    } else {
      console.log("value", target.value);
      
      if (name === "mediaUrl"){
        setIsLinkDisabled(false);
        setIsMediaDisabled(target.value.length > 0);
      }
  
      if (currentItemIndex !== null) {
        setPayload({
          ...payload,
          [payload[
            CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
          ][currentItemIndex][name]]: target.value,
        });
      }
      
      setNewVideo({ ...newVideo, [name]: target.value });
    }
  };
  
  const saveMediaHandler = () => {
    if (Object.keys(newVideo).length > 0) {
      if (!newVideo.mediaUrl && !newVideo.mediaFile) {
        showToast(CONSTANTS.APP_ERRORS.ADD_URL_OR_VIDEO, "error");
      } else if (!newVideo.name) {
        showToast(CONSTANTS.APP_ERRORS.TITLE_ERROR, "error");
      } else {
        let properName = newVideo.name.split(".")[0];
        let updatedMedia = [
          ...payload[
          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
          ],
        ];
        if (currentItemIndex !== null) {
          updatedMedia[currentItemIndex] = { ...newVideo, name: properName };
        } else {
          updatedMedia.push({ ...newVideo });
        }
        setPayload({
          ...payload,
          [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA]:
            updatedMedia,
        });
        setIsModalOpen(false);
        setNewVideo({
          name: "",
          status: "",
          type: "VIDEO",
        });
        setCurrentItemIndex(null);
      }
    } else {
      showToast(CONSTANTS.APP_ERRORS.EMPTY_FIELDS_ERROR, "error");
    }
  };

  const removeMediaFileHandler = () => { 
    setNewVideo({
      ...newVideo,
      [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.MEDIA_FILE]: null,
      [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME]: "",
    });
  
    setIsLinkDisabled(false);
  };
   
  const addNewRow = (rowFor: string) => {
    if (
      rowFor ===
      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_SKILLS
    ) {
      setPayload((prevPayload) => ({
        ...prevPayload,
        resourceSkills: [
          ...(prevPayload.resourceSkills || []),
          { name: "", rating: 0 }, // Initialize both name and rating
        ],
      }));
    } else {
      setPayload((prevPayload) => ({
        ...prevPayload,
        [rowFor]: [...(prevPayload[rowFor] || []), { name: "" }],
      }));
    }
  };

  const removeRow = (index: number, rowFor: string) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      [rowFor]: prevPayload[rowFor].filter((_: any, i: any) => i !== index),
    }));
  };

  const availiblityHandler = (availableAt: string, date?: string) => {
    if (availableAt === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT) {
      if (!date) {
        setSelectDateError(true);
      } else {
        setSelectDateError(false);
      }
      setPayload({
        ...payload,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
          .AVAILABILITY_STATUS]: availableAt,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.AVAILABLE_FROM]:
          date,
      });
    } else {
      delete payload[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.AVAILABLE_FROM
      ];
      setSelectDateError(false);
      setPayload({
        ...payload,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
          .AVAILABILITY_STATUS]: availableAt,
      });
    }
  };
  const changeHandler = (e: ChangeEvent, index?: number) => {
    const target = e.target as HTMLInputElement | null;
    target?.name ===
      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DISPLAY_NAME &&
      setDisplayNameMessage({ message: "", success: true });
    setIsFormUpdated(true);
    if (!target) return;
    if (index !== undefined) {
      const updatedData = [...(payload[target.name] || [])];

      if (target.type === "number") {
        if (parseInt(target.value) >= 0 && parseInt(target.value) <= 10) {
          updatedData[index] = {
            ...updatedData[index],
            rating: parseInt(target.value),
          }; // Handle rating update
        }
      } else {
        updatedData[index] = { ...updatedData[index], name: target.value };
      }

      setPayload({
        ...payload,
        [target.name]: updatedData,
      });
    } else {
      if (target.type === "file") {
        if (
          target?.files &&
          target?.files[0] &&
          target.files[0].type.split("/")[0] !== "image"
        ) {
          showToast(CONSTANTS.APP_ERRORS.ONLY_IMAGES_ERROR, "error");
        } else {
          let imageUrl = target.files
            ? URL.createObjectURL(target?.files[0])
            : "";
          setPayload({
            ...payload,
            [target.name]: target.files ? target.files[0] : null,
            imageUrl,
          });
        }
      } else {
        setPayload({ ...payload, [target.name]: target.value });
      }
    }
  };
  const confirmHandler = (isDraft: boolean) => { 
      Swal.fire({
        text: isDraft ? CONSTANTS.PROFILE_WILL_BE_DRAFT_TXT : CONSTANTS.PROFILE_WILL_BE_PUBLISHED_TXT,
        showCancelButton: true,
        confirmButtonText: CONSTANTS.CONFIRM_TXT,
        customClass: {
          cancelButton:
            "text-gray-800 bg-gray-300 rounded-full text-sm w-[100px]",
          confirmButton: "rounded-full bg-black text-sm w-[100px]",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          submitForm(isDraft ? "DRAFT" : "PUBLISHED");
        }
      });
  };

  const validateEmptyFields = () => {
    if (
      payload?.name === "" ||
      payload?.title === "" ||
      payload?.status === "" ||
      payload?.displayName === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  const submitForm = async (status?: string) => {
    try {
      if (validateEmptyFields() && !selectDateError) {
        setIsLoading(true);

        const finalPayload = convertToFormData({...payload, status});
        
        const response = await updateResource(finalPayload);
        
        if (response?.status !== 200) {
          const errorData = response.data;
          showToast(
            errorData.errors[Object.keys(errorData.errors)[0]][0],
            "error"
          );
          throw new Error(`HTTP Error! status: ${response.status}`);
        }

        let res = response.data;
        setCurrentProfile(res.data);
        setPayload(res.data);
        showToast(res.message, "success");
        setIsLoading(false);
      } else if (selectDateError) {
        showToast(CONSTANTS.APP_ERRORS.SELECT_AVAILABILITY_DATE, "error");
      } else {
        showToast(CONSTANTS.APP_ERRORS.EMPTY_FIELDS_ERROR, "error");
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(
        error?.response?.data?.message || CONSTANTS.APP_ERRORS.AN_ERROR_OCCURRED,
        "error"
      );
    }
  };

  const changeLocationHandler = async (
    e?: ChangeEvent<HTMLSelectElement>,
    state?: "education" | "experience" | "",
    id?: ""
  ) => {
    try {
      let name = e?.target?.name;
      setCityError("");
      setIsFormUpdated(true);
      if (name === CONSTANTS.COUNTRY_TXT || id) {
        let countryId = e?.target?.value || id;
        if (countryId) {
          const cityList = await getCityList(countryId);
          setCityOptions(cityList.data);
        } 
        let option: any = countryOptions.find(
          (opt: any) => opt?.id === e?.target.value
        );

        if (state === "education")
          setNewEdu({
            ...newEdu,
            country: option?.name,
            countryId: option?.id,
          });
        if (state === "experience")
          setNewExp({
            ...newExp,
            country: option?.name,
            countryId: option?.id,
          });
      } else if (state === "education") {
        let cityOption: any = cityOptions.find(
          (opt: any) => opt?.id === e?.target.value
        );
        setNewEdu({
          ...newEdu,
          locationId: e?.target?.value,
          city: cityOption?.name,
          cityId: cityOption?.id,
        });
      } else if (state === "experience") {
        let cityOption: any = cityOptions.find(
          (opt: any) => opt?.id === e?.target.value
        );
        setNewExp({
          ...newExp,
          locationId: e?.target?.value,
          city: cityOption?.name,
          cityId: cityOption?.id,
        });
      } else {
        setPayload({
          ...payload,
          cityId:
            e?.target?.value,
        });
      }
    } catch (e: any) {
      setCityError(e?.response?.data?.message);
    }
  };

  const statusHandler = async (status: string) => {
    try {
      setIsLoading(true);
      let res = await updateResourceStatus(currentProfile.id, status);
      showToast(res?.data?.message, "success");

      setIsLoading(false);
      navigate("/dashboard");
    } catch (e: any) {
      setIsLoading(false);
      showToast(e?.response?.data?.message, "error")
    }
  };

  const displayNameHandler = async (
    eOrDisplayName: Event | string | undefined
  ) => {
    let displayName = "";
    setIsFormUpdated(true);
    // Check if the parameter is an event
    if (eOrDisplayName && typeof eOrDisplayName !== "string") {
      const target = eOrDisplayName.target as HTMLInputElement;
      displayName = target.value.replaceAll(" ", "");
    } else if (typeof eOrDisplayName === "string") {
      displayName = eOrDisplayName.replaceAll(" ", "");
    }

    if (displayName) {
      let res = await verifyDisplayName(displayName);
      setPayload({
        ...payload,
        displayName: displayName,
      });
      setDisplayNameMessage({
        message: res.data.message,
        success: res.data.success,
      });
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (isFormUpdated) {
        event.preventDefault();
        event.returnValue = ""; // Required for Chrome to show the dialog
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isFormUpdated]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const list = await api.get(`/Resource/SearchResource/?id=${id}`);
        const countryData = await api.get(`/SystemLocation/GetAllCountry`);

        setCountryOptions(countryData.data?.data);
        setCurrentProfile(list?.data?.data);
        setPayload(list?.data?.data);
        setActiveTab(CONSTANTS.BASIC_INFO_TXT);

        if (list?.data?.data?.countryId) {
          await changeLocationHandler(undefined, "", list?.data?.data?.countryId);
        }

        list?.data?.data?.availableFrom && setIsDateVisible(true);
      } catch (error) {
        console.error("Error fetching resource summary:", error);
      }
      setIsLoading(false);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!showPreview ? (
        <div className="layout-container">
          <div className="lg:flex items-center justify-between">
            <div className="">
              <Breadcrumb
                path={[
                  { name: "Dashboard", url: "/dashboard" },
                  { name: "Modify Profile", url: "/modify-profile" },
                ]}
              />
              <div className="flex justify-center lg:justify-normal gap-2 mt-1 mb-1 lg:mb-0">
                <h1 className="font-medium overflow-hidden h-[25px] w-[160px] text-ellipsis whitespace-nowrap">
                  {currentProfile.name}
                </h1>
                <span className="text-xs uppercase font-bold text-tertiary-light pt-1">
                  {currentProfile.status}
                </span>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-center md:justify-end items-center gap-4">
              {currentProfile.displayName &&
                currentProfile?.status?.toLocaleLowerCase() ===
                CONSTANTS.PUBLISHED_TXT.toLocaleLowerCase() && (
                  <div className="text-blue-600 md:w-80 w-full text-sm gap-1 flex justify-center items-center">
                    <p className="overflow-hidden text-ellipsis h-[22px] whitespace-nowrap">{`${window.location.origin}/profile-detail/${currentProfile.displayName}`}</p>
                    <img
                      title={`${window.location.origin}/profile-detail/${currentProfile.displayName}`}
                      src={clipBoardIcon}
                      className="cursor-pointer"
                      alt="clipboard_icon"
                      onClick={() =>
                        copyToClipboard(
                          `${window.location.origin}/profile-detail/${payload.displayName}`,
                          showToast
                        )
                      }
                    />
                  </div>
                )}
              <div className="flex w-full justify-center flex-col md:flex-row gap-4">
                <Button
                  on_click_handler={() =>
                    statusHandler(currentProfile?.status?.toLocaleLowerCase() ===
                    CONSTANTS.DISABLED_TXT.toLocaleLowerCase() ? CONSTANTS.DRAFT_TXT.toLocaleUpperCase() : CONSTANTS.DISABLED_TXT.toLocaleUpperCase())
                  }
                  btn_label={currentProfile?.status?.toLocaleLowerCase() ===
                    CONSTANTS.DISABLED_TXT.toLocaleLowerCase() ? CONSTANTS.ENABLE_TXT : CONSTANTS.DISABLE_TXT}
                  other_classes="text-xs !h-8 md:!w-fit px-8"
                  type={"secondary"}
                />
                <Button
                  on_click_handler={() => setShowPreview(true)}
                  btn_label="Preview"
                  other_classes="text-xs !h-8 md:!w-fit px-10 !bg-gray-600"
                />
                <Button
                  on_click_handler={() =>
                    statusHandler(CONSTANTS.PUBLISHED_TXT)
                  }
                  btn_label={CONSTANTS.PUBLISH_TXT}
                  other_classes="text-xs !h-8 md:!w-fit px-10"
                  is_disable={currentProfile?.status?.toLocaleLowerCase() === CONSTANTS.PUBLISHED_TXT.toLocaleLowerCase()}
                />
              </div>
            </div>
          </div>

          <div>
            <div className="lg:flex flex-col lg:flex-row relative">
              <div className="w-fit m-auto">
                {/* Menu */}
                <ModifyProfileMenu
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                />
              </div>

              {isLoading ? (
                <div className="w-full flex items-center justify-center">
                  <LoadSpinner />
                </div>
              ) : (
                <div className="w-full relative">
                  {activeTab === CONSTANTS.BASIC_INFO_TXT && (
                    <BasicInformation
                      availabilityStatus={payload?.availabilityStatus}
                      country={payload?.countryId}
                      city={payload?.cityId}
                      displayName={payload?.displayName}
                      cityError={cityError}
                      name={payload?.name}
                      title={payload?.title}
                      description={payload?.description}
                      profileImage={payload?.imageUrl}
                      yearsOfExperience={payload?.yearsOfExperience}
                      skills={payload?.resourceSkills}
                      techStack={payload?.resourceTags}
                      changeHandler={changeHandler}
                      addNewRow={addNewRow}
                      removeRow={removeRow}
                      countryOptions={countryOptions}
                      changeLocationHandler={changeLocationHandler}
                      cityOptions={cityOptions}
                      isDateVisible={isDateVisible}
                      setIsDateVisible={setIsDateVisible}
                      availiblityHandler={availiblityHandler}
                      availableFrom={payload?.availableFrom}
                      displayNameMessage={displayNameMessage}
                      displayNameHandler={displayNameHandler}
                    />
                  )}
                  {activeTab === CONSTANTS.MEDIA_TXT && (
                    <MediaComponent
                      payload={payload}
                      mediaChangeHandler={mediaChangeHandler}
                      setPayload={setPayload}
                      saveMediaHandler={saveMediaHandler}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      newVideo={newVideo}
                      setNewVideo={setNewVideo}
                      setCurrentIndex={setCurrentItemIndex}
                      setIsLinkDisabled={setIsLinkDisabled}
                      setIsMediaDisabled={setIsMediaDisabled}
                      isLinkDisabled={isLinkDisabled}
                      isMediaDisabled={isMediaDisabled}
                      removeMediaFileHandler={removeMediaFileHandler}
                    />
                  )}
                  {activeTab === CONSTANTS.QNA_TXT && (
                    <QuestionAndAnswers
                      payload={payload}
                      setPayload={setPayload}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      quesChangeHandler={quesChangeHandler}
                      saveQuesHandler={saveQuesHandler}
                      newQuestion={newQuestion}
                      setNewQuestion={setNewQuestion}
                      setCurrentIndex={setCurrentItemIndex}
                    />
                  )}
                  {activeTab === CONSTANTS.EXPERIENCE_HEADING_TXT && (
                    <Experience
                      payload={payload}
                      expChangeHandler={journeyChangeHandler}
                      saveExpHandler={() => {
                        saveJourneyHandler(
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .RESOURCE_EXPERIENCE
                        );
                      }}
                      countryOptions={countryOptions}
                      cityOptions={cityOptions}
                      changeLocationHandler={changeLocationHandler}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setCurrentItemIndex={setCurrentItemIndex}
                      setNewExp={setNewExp}
                      cityError={cityError}
                      newExp={newExp}
                    />
                  )}
                  {activeTab === CONSTANTS.EDUCATION_HEADING_TXT && (
                    <Education
                      payload={payload}
                      eduChangeHandler={journeyChangeHandler}
                      saveEduHandler={() =>
                        saveJourneyHandler(
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .RESOURCE_EDUCATION
                        )
                      }
                      countryOptions={countryOptions}
                      cityOptions={cityOptions}
                      changeLocationHandler={changeLocationHandler}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setCurrentItemIndex={setCurrentItemIndex}
                      cityError={cityError}
                      setNewEdu={setNewEdu}
                      newEdu={newEdu}
                    />
                  )}
                  <div className="mt-4 flex flex-col md:flex-row justify-center lg:justify-end items-end">
                    <div className="w-full md:w-32 mb-4">
                      <Button
                        btn_label={CONSTANTS.CANCEL_TXT}
                        on_click_handler={() => navigate("/dashboard")}
                        type="secondary"
                      />
                    </div>
                    <div className="w-full md:w-32 ml-2 mb-4">
                      <Button
                        btn_label={CONSTANTS.SAVE_N_PUBLISH_TXT}
                        on_click_handler={()=>confirmHandler(false)}
                        other_classes={"!bg-primary hover:!bg-secondary"}
                      />
                    </div>
                    <div className="w-full md:w-32 ml-2 mb-4">
                      <Button
                        btn_label={CONSTANTS.SAVE_AS_DRAFT_TXT}
                        on_click_handler={()=>confirmHandler(true)}
                        other_classes={"!bg-black"}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <ProfilePreview
          currentProfile={payload}
          clickHandler={() => setShowPreview(false)}
          showBckBtn={true}
          btnTitle={CONSTANTS.BACK_TXT}
          showBreadCrumbs={false}
          showHeading={false}
        />
      )}
    </>
  );
};

export default ModifyProfile;
